import { OnboardingSteps, User } from "@/models";
import LoginService from "@/services/login.service";
import { Module, VuexModule, Action, Mutation } from "vuex-class-modules";

/** Holds the current user's context (profile/roles) and onboarding progress. */
@Module
export class Login extends VuexModule {
  private _context: User | null = null;
  private _onboarding: OnboardingSteps | null = null;

  @Mutation
  private setContext(information: any) {
    this._context = information;
  }
  @Mutation
  private setOnboarding(information: any) {
    this._onboarding = information;
  }

  /**
   * @deprecated Not called anywhere — views call `LoginService.login()` directly instead.
   * Also has a correctness bug: it returns `true` whenever the call doesn't throw, even if
   * `LoginService.login()` resolved to `false` (wrong credentials).
   */
  @Action
  async login(payload: any): Promise<boolean> {
    try {
      await LoginService.login(payload.username, payload.passwd);
      return true;
    } catch {
      return false;
    }
  }

  /** Loads the current user's context into the store. See {@link getContext}. */
  @Action
  public async context(): Promise<void> {
    const user = await await LoginService.context();
    this.setContext(user);
  }

  /** Loads the current user's onboarding progress into the store. See {@link getOnboarding}. */
  @Action
  public async onboarding(): Promise<void> {
    const onboarding = await await LoginService.onboarding();
    this.setOnboarding(onboarding);
  }

  /** The current user's context/profile, or `null` if not loaded. */
  get getContext(): User | null {
    return this._context;
  }

  /** The current user's onboarding progress, or `null` if not loaded. */
  get getOnboarding(): OnboardingSteps | null {
    return this._onboarding;
  }
}
